var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { leagueSortFunc } from '../../../../rendering-commons/Sorting';
import { cssClassMap } from '../../../../constants/SportCssMap';
import League from './League';
var Sport = function (props) {
    var sport = props.sport, leagues = props.leagues, timeFilter = props.timeFilter;
    var sportLeaguesIds = sport.get('leagues');
    var sportLeagues = sportLeaguesIds.map(function (l) { return leagues.get(l); });
    var renderLeagues = [];
    sportLeagues.sort(leagueSortFunc).map(function (league) {
        renderLeagues.push(_jsx(League, { league: league, timeFilter: timeFilter }, league));
    });
    var sportCssClass = "".concat(cssClassMap[sport.get('id')]);
    return (_jsx("div", __assign({ className: 'table' }, { children: _jsx("table", __assign({ className: "calendar-table sport-name sport-".concat(sportCssClass, " show") }, { children: _jsxs("tbody", { children: [_jsx("tr", { children: _jsx("td", __assign({ className: 'typeTD' }, { children: _jsx("div", __assign({ className: "type ".concat(sportCssClass) }, { children: props.sport.get('name') })) })) }), renderLeagues] }) })) })));
};
Sport.propTypes = {
    leagues: PropTypes.object.isRequired,
    timeFilter: PropTypes.any
};
var mapStateToProps = function (state) {
    return {
        leagues: state.application.getIn(['timetable', 'leagues'])
    };
};
Sport = connect(mapStateToProps)(Sport);
export default Sport;



// WEBPACK FOOTER //
// ./src/components/grid/live/timetable/Sport.jsx